var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRfidAbierto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECT",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    fill: "#FFC107",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 13h-14v-4a6 6 0 0 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0 -16 0v4a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-12a3 3 0 0 0 -3-3zm1 15a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1-1v-12a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16 24.9a1 1 0 0 0 -1 1v.1a1 1 0 0 0 2 0v-.1a1 1 0 0 0 -1-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16 17a8.13 8.13 0 0 0 -5.69 2.28 1 1 0 0 0 1.38 1.44 6.26 6.26 0 0 1 8.62 0 1 1 0 0 0 .69.28 1 1 0 0 0 .72-.31 1 1 0 0 0 0-1.41 8.13 8.13 0 0 0 -5.72-2.28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16 20.77a5 5 0 0 0 -3.75 1.74 1 1 0 0 0 1.5 1.33 3 3 0 0 1 4.5 0 1 1 0 0 0 .75.33 1 1 0 0 0 .66-.25 1 1 0 0 0 .09-1.41 5 5 0 0 0 -3.75-1.74z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfidAbierto);
export default __webpack_public_path__ + "static/media/rfidAbierto.b480273663679d3d1223fabecb5d44ab.svg";
export { ForwardRef as ReactComponent };